import { PropsWithChildren, useEffect, useState } from 'react';
import {
  ApplicationHeader,
  axiosInstance,
  FIDES_CLIENTID,
  TokenRefreshProvider,
  useConfigStore,
  UsersMenuRoute,
  useTranslation,
} from '@fides/fides-react-components';
import { endpoints } from 'core/consts';
import { GlobalConfig, VersionInformation } from 'core/interfaces';
import { useGlobalConfigContext } from 'core/contexts/GlobalConfig';
import { AxiosResponse } from 'axios';
import { Log } from 'core/helpers/initApp';
import { MainContent } from '../ApplicationHeaderPage';

export const EndUserHeader = (props: PropsWithChildren) => {
  const { t } = useTranslation();
  const { children } = props;
  const [dlcVersion, setDlcVersion] = useState('');
  const globalConfig: GlobalConfig = useGlobalConfigContext();
  const { user, accessHelper } = globalConfig;
  const { portalUrl } = useConfigStore.getState();

  const appVersion = process.env.REACT_APP_VERSION;
  const buildNumber = process.env.REACT_APP_BUILD_NUMBER;

  useEffect(() => {
    axiosInstance
      .get(endpoints.version, { baseURL: endpoints.DLCApiUrl })
      .then((response: AxiosResponse<VersionInformation>) => {
        setDlcVersion(response.data.build);
      })
      .catch((error) => {
        Log.error(error);
        setDlcVersion('server error');
      });
  }, [dlcVersion]);

  const getUserMenuTypes = (): UsersMenuRoute[] => {
    const userMenuTypes = [
      {
        name: t('generic.personalSetting'),
        url: `/user/settings`,
      },
      {
        name: t('generic.changePassword'),
        url: `/user/change-password`,
      },
      {
        name: t('generic.logout'),
        url: `/logout`,
      },
    ];

    if (accessHelper.isImpersonatedAsClient) {
      userMenuTypes.shift();
    }

    if (user.clientId === FIDES_CLIENTID || user.impersonated) {
      userMenuTypes.splice(1, 1);
    }

    return userMenuTypes;
  };

  return (
    <>
      <TokenRefreshProvider portalUrl={portalUrl.replace(/\/+$/, '')} />
      <ApplicationHeader
        appName='Download Center'
        appVersion={appVersion}
        buildNumber={`Frontend:${buildNumber} Backend:${dlcVersion}`}
        displayCompanyLogo
        navRoutes={[]}
        menuOptions={{
          user: user ? { username: user?.userName, userDisplayName: `${user?.domainUser.fullName}` } : undefined,
          showUserMenu: true,
          showDownloadCenterMenu: false,
          userMenuRoutes: getUserMenuTypes(),
          showMasterDataMenu: false,
        }}
      />
      <MainContent $variant='medium'>{children}</MainContent>
    </>
  );
};
